import { Action } from 'redux';
import { SetNavLocation } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetNavLocationAction extends Action {
  routerStateName: string;
}

export function setNavLocation(routerStateName: string): SetNavLocationAction {
  return {
    type: SetNavLocation,
    routerStateName: routerStateName
  };
}

export const isSetNavLocationAction = isActionFactory<SetNavLocationAction>(SetNavLocation);
